export default __webpack_public_path__ + "static/media/identification.4e974108.svg";